<template>
  <div>
    <!-- main area start -->
    <main>
      <!-- hero area start -->
      <div id="apork-hero" class="apork-hero-area hero-bg position-relative">
        <div class="hero-style-shape">
          <img
            class="style-shape shape-1"
            src="@/assets/picture/shape-1.png"
            alt=""
          />
          <img
            class="style-shape shape-2"
            src="@/assets/picture/shape-2.png"
            alt=""
          />
          <img
            class="style-shape aporkrot shape-3"
            src="@/assets/picture/shape-3.png"
            alt=""
          />
        </div>
        <div class="container">
          <div class="row">
            <div class="col-xl-7 col-lg-8 col-md-12">
              <div class="hero-content">
                <h2>椒椒我</h2>
                <h4 style="color: #fff;">遇见心动的Ta</h4><br/>
                <p>
                  交友不随便，只要玩得来；多人连麦语音，快乐互动派对；<br />
                  遇见怦然心动的人，就是遇到甜甜的恋爱。
                </p>
                <div class="hero-btn">
                  <a @click="download" class="btn btn-type-2">
                    <img
                      alt="椒椒我"
                      src="@/assets/picture/icon_android.png"
                      width="25px"
                      height="32px"
                    />
                    立即下载
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xl-4 offset-xl-1 col-lg-4 wow fadeInRight">
              <div class="hero-mobile-img">
                <img src="@/assets/picture/hero-mobile-1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- hero area end -->
      <!-- about area start -->
      <div id="apork-about-area" class="apork-about-area mt-230">
        <div class="container">
          <div class="row">
            <div class="col-xl-8 col-lg-8 mx-auto">
              <div class="section-title text-center mb-80">
                <h2>关于软件</h2>
                <p>更有趣的年轻人社交APP，让你快速找到对的人</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 wow fadeInLeft">
              <div class="about-img">
                <img src="@/assets/picture/about-1.png" alt="about-1" />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 wow fadeInRight">
              <div class="about-content mt-110 mb-90">
                <img src="@/assets/picture/about-icon-1.png" alt="" />
                <h3>
                  欢迎更多 爱社交 爱游戏 爱旅游 爱收集 密友们加入
                  <span>椒椒我</span>
                </h3>
                <p>
                  在椒椒我可以跟慕恋的女生投递爱意、跟久未联系的好友叙旧追忆、跟游戏的战友连线配合等，还有更多陌生人交友功能等你来发现。
                </p>
                <router-link to="/features" class="btn btn-type-2 mt-30"
                  >查看更多</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- about area end -->
      <!-- counter area start -->
      <IndexCounter></IndexCounter>
      <!-- counter area end -->
      <!-- features area start -->
      <div
        id="apork-features-area"
        class="apork-features-area position-relative"
      >
        <div class="features-bg-shape">
          <img
            src="@/assets/picture/bg-shape-1.png"
            alt=""
            class="style-shape fbs-1"
          />
          <img
            src="@/assets/picture/bg-shape-2.png"
            alt=""
            class="style-shape fbs-2"
          />
        </div>
        <div class="container">
          <div class="row">
            <div class="col-xl-8 col-lg-8 mx-auto">
              <div class="section-title text-center mb-80">
                <h2>App 功能介绍</h2>
                <p>更有趣的年轻人社交APP，让你快速找到对的人。</p>
              </div>
            </div>
          </div>

          <div class="row text-center">
            <div class="col-xl-4 col-lg-4 col-md-4 wow fadeInLeft">
              <div class="single-features">
                <img
                  src="@/assets/picture/icon-1.png"
                  alt=""
                  style="width: 80px; height: 80px"
                />
                <h3>群聊派对</h3>
                <p>
                  一群有趣的人在这里等你，和志同道合的朋友在派对里尽情狂欢，帮助你快速结交新朋友。
                </p>
                <div class="features-shape">
                  <img src="@/assets/picture/shape-1.png" alt="" />
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-4 wow fadeInUp">
              <div class="single-features">
                <img
                  src="@/assets/picture/icon-2.png"
                  alt=""
                  style="width: 80px; height: 80px"
                />
                <h3>声控交友</h3>
                <p>
                  声入人心，用声音认识新朋友，喜欢谁的声音用接唱开启对话，越玩越会爱上陌“声”人。
                </p>
                <div class="features-shape">
                  <img src="@/assets/picture/shape-2.png" alt="" />
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-4 wow fadeInRight">
              <div class="single-features">
                <img
                  src="@/assets/picture/icon-3.png"
                  alt=""
                  style="width: 80px; height: 80px"
                />
                <h3>私密畅聊</h3>
                <p>
                  我们贴心为你保护隐身，和相似的人聊有趣的事，不怕尬场，尽情交流兴趣与观点吧。
                </p>
                <div class="features-shape">
                  <img src="@/assets/picture/shape-3.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- features area end -->
      <!-- screenshot area start -->
      <div id="apork-screenshot-area" class="apork-screenshot-area mb-110">
        <div class="container">
          <div class="row">
            <div class="col-xl-8 col-lg-8 mx-auto">
              <div class="section-title text-center mb-80">
                <h2>App 部分页面</h2>
                <p>更有趣的年轻人社交APP，让你快速找到对的人。</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="screenshot-slider">
                <IndexSwiper></IndexSwiper>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- screenshot area end -->
      <!-- call to action area start -->
      <div id="cta-area" class="cta-area pt-140 pb-140">
        <div class="container">
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
              <div class="cta-content">
                <h3>
                  我们在椒椒我等着你哦 <br />
                  赶快加入我们吧 <i class="fa fa-long-arrow-right"></i>
                </h3>
                <div class="cta-btn float-right">
                  <a href="#" class="btn btn-type-4"
                    >去下载 <i class="fa fa-download"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- call to action area end -->
      <!-- faq area start -->
      <FaqArea></FaqArea>
      <!-- faq area end -->
    </main>
    <!-- main area end -->

    <!-- scrolltop button -->
    <div class="material-scrolltop"></div>
  </div>
</template>

<script>
import IndexSwiper from "@/views/homePage/index/IndexSwiper";
import FaqArea from "@/views/homePage/index/FaqArea.vue";
import IndexCounter from "@/views/homePage/index/IndexCounter.vue";
export default {
  components: {
    IndexSwiper,
    FaqArea,
    IndexCounter
  },
  data() {
    return {
      code: ''
    };
  },
  created() {},
  mounted() {
    if(this.$route.query.code){
      this.code = this.$route.query.code
      this.copyText(this.code)
    }
    new this.$wow.WOW().init();
  },
  methods:{
    async copyText(text){
      console.log("copyText:", text)
      try {
        if (navigator.clipboard && navigator.permissions) {
          await navigator.clipboard.writeText(text)
        } else {
          const textArea = document.createElement('textArea')
          textArea.value = text
          textArea.style.width = 0
          textArea.style.position = 'fixed'
          textArea.style.left = '-999px'
          textArea.style.top = '10px'
          textArea.setAttribute('readonly', 'readonly')
          document.body.appendChild(textArea)

          textArea.select()
          document.execCommand('copy', false, text)
          document.body.removeChild(textArea)
        }
      }catch (err){
        console.log('copyText error:', err)
      }
    },
    download(){
      try {
        console.log("download:", this.code)
        this.$copyText(this.code)
      }catch (err) {
        console.log("err:", err)
      }
      location.href = 'https://www.xinyucp.cn/downloads/jiaojiaowo.apk';
    }
  }
};
</script>

<style lang="less" scoped>
</style>